import Vue from 'vue'
import Vuex from 'vuex'
import NativeAbout from './module/NativeAbout'
Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    NativeAbout
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js